module.exports = __webpack_public_path__ + "8b91766e88e8d13baba3728d768eb7fc.pdf";


//////////////////
// WEBPACK FOOTER
// ./app/assets/data/coloring/fr4.pdf
// module id = 930
// module chunks = 3